import React from 'react'
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { ToastContainer } from 'react-toastify';
import { hostTitle, isHostProactive, domainName } from '../../../config/ui';
import {
  // getToken,
  authContext
} from '../../../config/adalConfig'

import Content from '../components/Content';
import UiValidate from '../../../components/forms/validation/UiValidate'
import { logout } from '../../../store/current-user/CurrentUserActions'
import store from '../../../store/configureStore'

import { signIn } from "../../../store/auth/AuthActions";


class SignIn extends React.Component {
  azureLogin(e) {
    e.preventDefault();

    // if (!getToken()) {
    logout();
    authContext.login();
    // }
  }

  onSubmit(e) {
    e.preventDefault();
    const $form = $(this.refs.form);
    const $email = $(this.refs.email);
    const $password = $(this.refs.password);
    if ($form.data('validator')) {
      if ($form.valid()) {
        store.dispatch(signIn($email.val(), $password.val()));
      }
    }
  }

  render() {
    const { auth } = this.props;
    let error = null;
    if (auth && auth.signinMeta) {
      if (auth.signinMeta.status === 401) {
        error = 'User not found or incorrect password.';
      }
    }

    let buttonClass = "btn-danger";
    let signInButton = "btn-primary";
    let forgotPasswordClass = "note";
    if (isHostProactive()) {
      buttonClass = "btn-custom";
      signInButton = "btn-primary-custom";
      forgotPasswordClass = "note-custom";
    }


    return (
      <div id="extr-page">
        <Helmet title={`Sign In – ${hostTitle()}`} />
        <header id="header" className="animated fadeInDown">

          <div id="logo-group">
            <span id="logo"> <img src={`assets/img/${domainName()}logo.png`} alt="SmartAdmin" /> </span>
          </div>

          {/*<span id="extr-page-header-space"> <span className="hidden-mobile hiddex-xs">Need an account?</span>&nbsp;<a*/}
          {/*  href="#/register" className={`btn ${buttonClass}`}>Create account</a> </span>*/}

        </header>
        <div id="main" role="main" className="animated fadeInDown">

          <div id="content" className="container">
            <div className="row">
              <Content className="col-xs-12 col-sm-12 col-md-7 col-lg-8 hidden-xs hidden-sm" />
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4">
                <div className="well no-padding">
                  <UiValidate>
                    <form onSubmit={this.onSubmit.bind(this)} ref="form" action="#/dashboard" id="login-form" className="smart-form client-form">
                      <header>
                        Sign In
                      </header>
                      {error && <div className="alert adjusted alert-danger fade in">{error}</div>}
                      <fieldset>
                        <section>
                          <label className="label">E-mail</label>
                          <label className="input"> <i className="icon-append fa fa-user" />
                            <input ref="email" type="email" name="email" data-smart-validate-input="" data-required="" data-email=""
                              data-message-required="Please enter your email address"
                              data-message-email="Please enter a VALID email address"
                              autoComplete="username" />
                            <b className="tooltip tooltip-top-right"><i className="fa fa-user txt-color-teal" />
                              Please enter email address/username</b></label>
                        </section>
                        <section>
                          <label className="label">Password</label>
                          <label className="input"> <i className="icon-append fa fa-lock" />
                            <input ref="password" type="password" name="password" data-smart-validate-input="" data-required=""
                              data-minlength="3" data-maxnlength="20"
                              data-message="Please enter your email password"
                              autoComplete="current-password" />
                            <b className="tooltip tooltip-top-right"><i className="fa fa-lock txt-color-teal" /> Enter
                              your password</b> </label>
                          <div className={`${forgotPasswordClass}`}>
                            <a href="#/forgot">Forgot password?</a>
                          </div>
                        </section>
                        <section className="hide">
                          <label className="checkbox">
                            <input ref="remember" type="checkbox" name="remember" defaultChecked={true} />
                            <i />Stay signed in</label>
                        </section>
                      </fieldset>
                      <footer>
                        <button type="submit" className={`btn ${signInButton}`} disabled={auth.isLoading}>
                          Sign in
                        </button>
                      </footer>
                      {auth.isLoading &&
                        <div className="cover">
                          <div className="spinner inline"></div>
                        </div>
                      }
                    </form>
                  </UiValidate>
                </div>

              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    )
  }
}

export default connect(
  state => ({ auth: state.auth }),
  dispatch => ({
    signIn: () => dispatch(signIn()),
  }),
)(SignIn);



// WEBPACK FOOTER //
// ./src/routes/auth/containers/SignIn.js